import { OperatorInterface } from "utils"

export const MOUSTACHE_NAME = "Moustache"
export const MOUSTACHE_ID = "MC"
export const MOUSTACHE_SUBDOMAIN = "moustache"

export const moustacheConfiguration: OperatorInterface = {
		name: MOUSTACHE_NAME,
		id: MOUSTACHE_ID,
		subDomain: MOUSTACHE_SUBDOMAIN,
        url: "moustache.o-code.co",
        // TODO: Add legals documents for Moustache
        cguUrl: "",
	    legalNoticeUrl: "",
	    privacyPolicyUrl: "",
		folderName: "moustache",
		faqAccordionLength: 6,
		theme: {
            primaryColor: "#1d1d1d",
            primaryColorHover: "#00537d",
			primaryColorLigthen: "#FFFEFC",
            secondaryColor: "#1d1d1d",
            formBackgroundColor: "#F7F8F9",
            secondaryColorLighten: "#F6AEA1",
            secondaryColorHover: "#636363",
            placeholderColor: "#93C2CF",
		}
}